import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

// LA CARTE DU LIEU D'UNE DATE : Leaflet et les tuiles d'OpenStreetMap.
//
// LIBRE, GRATUIT, SANS CLÉ NI COOKIE TIERS — donc rien à configurer par site, et une compagnie qui
// installe La Fonderie a sa carte sans démarche. C'est ce qui a décidé du choix : un fournisseur à
// clé aurait demandé une variable d'environnement de plus à chaque déploiement, et une carte
// absente là où personne n'y aurait pensé.
//
// Balisage attendu : un conteneur `data-controller="map"` portant les deux coordonnées en décimal et
// une étiquette. Le conteneur DOIT avoir une hauteur — une carte sans hauteur ne se voit pas.
export default class extends Controller {
  static values = {
    latitude: Number,
    longitude: Number,
    label: String,
    zoom: { type: Number, default: 15 }
  }

  connect() {
    // Sans coordonnées, aucune carte. Pas de repli sur [0, 0] : ce point existe, au large du golfe
    // de Guinée, et une carte qui l'affiche a l'air de fonctionner.
    if (!this.hasLatitudeValue || !this.hasLongitudeValue) return

    const position = [this.latitudeValue, this.longitudeValue]
    this.map = L.map(this.element, { scrollWheelZoom: false }).setView(position, this.zoomValue)

    // LE PRÉFIXE D'ATTRIBUTION DE LEAFLET EST RETIRÉ : depuis sa version 1.9, il affiche un DRAPEAU
    // UKRAINIEN à côté du nom de la bibliothèque. Rien ne justifie un signe politique sur la carte
    // d'une salle de spectacle, et le projet s'interdit ce genre de contenu partout ailleurs.
    //
    // Seule l'attribution des DONNÉES est obligatoire — celle d'OpenStreetMap, posée par la couche
    // de tuiles juste en dessous, et elle reste. Le crédit de la bibliothèque, lui, ne l'a jamais
    // été.
    this.map.attributionControl.setPrefix(false)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap",
      maxZoom: 19
    }).addTo(this.map)

    const marker = L.marker(position, { icon: this.#markerIcon() }).addTo(this.map)
    if (this.hasLabelValue && this.labelValue) marker.bindPopup(this.labelValue)

    this.#watchSize()
  }

  disconnect() {
    this.observateur?.disconnect()
    this.observateur = null
    this.map?.remove()
    this.map = null
  }

  // LA CARTE NAÎT DANS UN PANNEAU REPLIÉ, donc dans un conteneur de taille nulle : Leaflet s'y
  // initialise sur zéro pixel et n'affiche que du gris une fois le panneau ouvert. On lui redemande
  // ses dimensions dès que le conteneur en a. Sans effet quand la carte est visible d'emblée.
  #watchSize() {
    this.observateur = new ResizeObserver(() => {
      if (this.element.clientWidth > 0 && this.element.clientHeight > 0) this.map?.invalidateSize()
    })
    this.observateur.observe(this.element)
  }

  // LE MARQUEUR EST DESSINÉ EN HTML, et non chargé comme image : les icônes livrées avec Leaflet
  // pointent des fichiers dont le chemin casse une fois le paquet assemblé — un marqueur invisible,
  // sans erreur, sur une carte par ailleurs juste.
  #markerIcon() {
    return L.divIcon({
      className: "",
      html: '<span style="display:block;width:18px;height:18px;border-radius:50%;background:#c2410c;border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></span>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
      popupAnchor: [0, -10]
    })
  }
}
